import React from "react";
import Layout from "src/components/Layout";
import "./TrainingCenter.css";
import image from "../../images/8.png";
import InfoCard from "src/components/InfoCard";

const trainingcenter: React.FC = () => {
  return (
    <Layout>
      <InfoCard title={"Training Center"} image={image}>
        <div className="training-details">
          <p>
            <strong>
              FIRST AID AT WORK & OXYGEN ADMINISTRATION<br></br>
            </strong>
            <br></br> It is for workplaces where there are more significant
            health and safety risks are more likely to need a trained first
            aider and the course runs for 3 days in accordance with HSE
            guidelines, and it is valid for 3 years. ''Highly required for
            professional divers.''
          </p>
          <p>
            <strong>
              AMERICAN SAFETY & HEALTH INSTITUTE (ASHI)<br></br>
            </strong>
            <br></br> DOTMEDICA has been recently accredited by ASHI. ASHI is an
            association of health and safety educators based in USA. It provides
            certification in lifesaving topics for laypeople, professionals, and
            organizations that need or want to meet regulatory requirements.
            <br></br>
            <br></br>https://emergencycare.hsi.com/compliance-and-qa<br></br>
            <br></br>The Occupational Safety and Health Administration
            (OSHA) and the American Safety & Health Institute (ASHI), recognize
            the value of establishing a collaborative relationship to foster
            safer and more healthful American workplaces. OSHA and ASHI
            recognize that OSHA's State Plan and Consultation Project partners
            are an integral part of the OSHA national effort.<br></br>
            <br></br>
            <br></br> https://www.osha.gov/alliances/ashi/ashi
          </p>
          <p>
            <strong>
              ASHI available courses are:<br></br>
            </strong>
            <br></br>
            1. Basic First Aid:<br></br>
            <br></br>Covers first aid basics and prepares students to deliver
            first aid in a safe and timely manner. Also shows how to prevent
            injuries and illnesses.<br></br>
            <br></br>2. Advanced First Aid:<br></br>
            <br></br>Designed for non-EMS responders including government,
            corporate, industry, lifeguards, security personnel, law
            enforcement, corrections personnel, and other individuals who are
            not EMS or healthcare providers but desire or require certification
            in Advanced First Aid training.<br></br>
            <br></br> 3. CPR and AED:<br></br>
            <br></br> An extremely flexible CPR and AED certification program
            that teaches how to recognize cardiac arrest, activate emergency
            medical services, and respond appropriately until additional
            assistance arrives. Also covers how to respond to urgent choking
            situations.<br></br>
            <br></br> 4. CPR, AED and First Aid COMBO:<br></br>
            <br></br> This first aid, AED, and CPR training course builds the
            skills and confidence to respond to the most typical
            life-threatening emergencies. Ideal for those seeking a
            comprehensive emergency care class.<br></br>
            <br></br> 5. Emergency Oxygen:<br></br>
            <br></br> Focuses on administering emergency oxygen to individuals,
            emergency oxygen delivery systems, and integrating pulse oximetry.
            <br></br> 6. Basic Life Support (BLS):<br></br>
            <br></br>Trains healthcare providers and professional responders how
            to recognize a life-threatening emergency, how to provide basic life
            support, and what to do in case of an airway obstruction or choking.
            <br></br>
          </p>
        </div>
      </InfoCard>
    </Layout>
  );
};

export default trainingcenter;
